import BaseApiAction from '@Actions/base-api-action';
export default class CheckFlags extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'users-temp-checkFlags',
      payload: {
        user_id: this._payload.user_id,
        flag_id: this._payload.flag_id || null,
        action: this._payload.action || 'REQUEST'
      }
    });
  }
}
